<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备ID')">
              <a-input :placeholder="$t('请输入设备ID')" v-model="queryParam.deviceId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('报警状态')">
              <j-dict-select-tag v-model="queryParam.warnStatus" :placeholder="$t('请输入报警状态')" dictCode="wq_warn_status" ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('处理时间')">
              <j-date :placeholder="$t('请选择处理时间')" v-model="queryParam.solvedTime"></j-date>
            </a-form-item>
          </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <a-button type="primary" icon="download" @click="handleExportXls('wq_data_last_record')">{{ $t('导出') }}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('处理') }}</a>
        </span>
        <template slot="warnStatus" slot-scope="text,record">
          <span v-if="record.warnStatus == 0" class="normalbg-status">{{ $t('正常') }}</span>
          <span v-else class="unusualbg-status">{{ $t('异常') }}</span>
        </template>
      </a-table>
    </div>
    <wQ-data-last-record-modal ref="modalForm" @ok="modalFormOk"></wQ-data-last-record-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { isUndefined,isNull } from'@/utils/validate'
  import WQDataLastRecordModal from './modules/WQDataLastRecordModal'
  import JDate from '@/components/jeecg/JDate.vue'
  function judgeStandard(min,max,num) {
    if(isNull(min)&&isNull(max)) {
      return true
    }else {
      if(!isNull(max)&&Number(min)>Number(num)) {
        return false
      }else if(!isNull(min)&&Number(max)<Number(num)) {
        return false
      }
    }
    return true
  }
  export default {
    name: 'WQDataLastRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDate,
      WQDataLastRecordModal
    },
    data () {
      return {
        description: 'wq_data_last_record管理页面',
        date:[],
        url: {
          list: "/wq/wQDataLastRecord/list",
          delete: "/wq/wQDataLastRecord/delete",
          deleteBatch: "/wq/wQDataLastRecord/deleteBatch",
          exportXlsUrl: "/wq/wQDataLastRecord/exportXls",
          importExcelUrl: "wq/wQDataLastRecord/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('设备ID'),
            align:"center",
            dataIndex: 'deviceId',

          },{
            title: this.$t('报警状态'),
            align:"center",
            dataIndex: 'warnStatus',
            scopedSlots: { customRender: 'warnStatus' },
          },{
            title: this.$t('接收时间'),
            align:"center",
            dataIndex: 'updateTime',
          },{
            title: this.$t('酸碱度(pH)'),
            align:"center",
            dataIndex: 'ph',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.ph_down,remark.ph_up,r.ph)) {
                return <span style="color:green">{r.ph}</span>
              }
              return <span style="color:red">{r.ph}</span>
            }
          },{
            title: this.$t('温度(℃)'),
            align:"center",
            dataIndex: 'temp',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.temp_down,remark.temp_up,r.temp)) {
                return <span style="color:green">{r.temp}</span>
              }
              return <span style="color:red">{r.temp}</span>
            }
          },{
            title: this.$t('浊度(NTU)'),
            align:"center",
            dataIndex: 'ss',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.ss_down,remark.ss_up,r.ss)) {
                return <span style="color:green">{r.ss}</span>
              }
              return <span style="color:red">{r.ss}</span>
            }
          },{
            title: this.$t('余氯(mg/L)'),
            align:"center",
            dataIndex: 'fcl',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.fcl_down,remark.fcl_up,r.fcl)) {
                return <span style="color:green">{r.fcl}</span>
              }
              return <span style="color:red">{r.fcl}</span>
            }
          },{
            title: this.$t('溶解氧(mg/L)'),
            align:"center",
            dataIndex: 'doo',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.doo_down,remark.fcl_up,r.doo)) {
                return <span style="color:green">{r.doo}</span>
              }
              return <span style="color:red">{r.doo}</span>
            }
          },{
            title: 'ORP(mv)',
            align:"center",
            dataIndex: 'orp',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.orp_down,remark.orp_up,r.orp)) {
                return <span style="color:green">{r.orp}</span>
              }
              return <span style="color:red">{r.orp}</span>
            }
          },{
            title: this.$t('电导率(mS/cm)'),
            align:"center",
            dataIndex: 'ec',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.ec_down,remark.ec_up,r.ec)) {
                return <span style="color:green">{r.ec}</span>
              }
              return <span style="color:red">{r.ec}</span>
            }
          },{
            title: this.$t('氨氮(mg/L)'),
            align:"center",
            dataIndex: 'nh3n',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.nh3n_down,remark.nh3n_up,r.nh3n)) {
                return <span style="color:green">{r.nh3n}</span>
              }
              return <span style="color:red">{r.nh3n}</span>
            }
          },{
            title: this.$t('化学耗氧量(mg/L)'),
            align:"center",
            dataIndex: 'chemo',
            customRender: (t,r,index) => {
              let remark = JSON.parse(r.remark)
              if(judgeStandard(remark.chemo_down,remark.chemo_up,r.chemo)) {
                return <span style="color:green">{r.chemo}</span>
              }
              return <span style="color:red">{r.chemo}</span>
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.$t("处理");
      this.$refs.modalForm.disableSubmit = false;
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
